__turbopack_context__.v({
  "ctaBtn": "SoftwareFeatures-module__1iPDwq__ctaBtn",
  "eyebrow": "SoftwareFeatures-module__1iPDwq__eyebrow",
  "featureItem": "SoftwareFeatures-module__1iPDwq__featureItem",
  "featureText": "SoftwareFeatures-module__1iPDwq__featureText",
  "featuresCol": "SoftwareFeatures-module__1iPDwq__featuresCol",
  "floatL": "SoftwareFeatures-module__1iPDwq__floatL",
  "floatR": "SoftwareFeatures-module__1iPDwq__floatR",
  "left": "SoftwareFeatures-module__1iPDwq__left",
  "notch": "SoftwareFeatures-module__1iPDwq__notch",
  "phone": "SoftwareFeatures-module__1iPDwq__phone",
  "right": "SoftwareFeatures-module__1iPDwq__right",
  "screen": "SoftwareFeatures-module__1iPDwq__screen",
  "sectionHead": "SoftwareFeatures-module__1iPDwq__sectionHead",
  "sectionTitle": "SoftwareFeatures-module__1iPDwq__sectionTitle",
  "softwareFeatures": "SoftwareFeatures-module__1iPDwq__softwareFeatures",
  "subtitle": "SoftwareFeatures-module__1iPDwq__subtitle",
  "tray": "SoftwareFeatures-module__1iPDwq__tray",
});
